import React from 'react'
import {createSvgIcon} from "@mui/material"

export default createSvgIcon(
    <svg className="expanded-icon" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path d="m 20.6 7.4 c -0.3 -0.3 -0.8 -0.3 -1.1 0 l -7 7 l -7 -7 c -0.3 -0.3 -0.8 -0.3 -1.1 0 c -0.3 0.3 -0.3 0.8 0 1.1 l 7.5 7.5 c 0.1 0.1 0.3 0.2 0.6 0.2 s 0.4 -0.1 0.6 -0.2 l 7.5 -7.5 c 0.3 -0.3 0.3 -0.8 0 -1.1 z"></path>
    </svg>, "expanded"
)
